import styled, {css} from 'styled-components';
import {DEVICE, MainLoader} from '@chekin/guestapp-ui-kit';
import {Fields as FieldGroupContent} from 'components/FieldsGroup/styled';
import ModalSheet from 'components/common/ModalSheet';

type FieldsProps = {
  $rowsCount: number;
  $hasSignature?: boolean;
};

export const Fields = styled.div<FieldsProps>`
  display: grid;
  grid-column-gap: 40px;
  grid-template-columns: 1px [content-start] 1fr 1fr [content-end] 1px;
  grid-template-rows: repeat(${props => props.$rowsCount}, auto);
  justify-items: center;

  width: 100%;
  text-align: center;
  max-width: 778px;
  position: relative;
  ${props =>
    !props.$hasSignature &&
    css`
      margin: 0 auto;
    `};

  ${FieldGroupContent} {
    grid-column: content-start / content-end;
    grid-template-columns: subgrid;
  }

  @media (max-width: ${DEVICE.laptop}) {
    grid-column-gap: 10px;
    grid-template-columns: 1fr;
    grid-column: unset;

    ${FieldGroupContent} {
      grid-column: unset;
      grid-template-columns: unset;
    }
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    display: flex;
    max-width: 463px;
  }
`;
export const FormWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  column-gap: 30px;
  padding: 0 0 40px;
  justify-content: center;

  @media only screen and (max-width: ${DEVICE.laptopL}) {
    flex-direction: column;
    align-items: center;
    row-gap: 12px;
    max-width: 702px;
  }

  @media only screen and (max-width: ${DEVICE.laptop}) {
    flex-direction: column;
    align-items: center;
    row-gap: 28px;
    padding: 0 4px 130px;
  }
`;

export const MainStyledLoader = styled(MainLoader)`
  margin-top: 60px;
  margin-bottom: 24px;
`;

export const LoadingContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: column;
`;

export const LoadingText = styled.span`
  font-style: normal;
  font-weight: ${props => props.theme.fonts.fontWeight.mediumL};
  font-size: ${props => props.theme.fonts.sizes.large};
  line-height: 24px;
  text-align: center;
  -webkit-letter-spacing: 0.36px;
  -moz-letter-spacing: 0.36px;
  -ms-letter-spacing: 0.36px;
  letter-spacing: 0.36px;
  color: ${props => props.theme.colors.$p10};
`;

export const StyledAutoCompleteGuestDataModalSheet = styled(ModalSheet)`
  &-content {
    body[data-layout-mode='kiosko'] & .modal__close-bt {
      top: 20px;
      right: 20px;
    }
  }
`;
